import { mastheadMeta } from "@/mocks/homeData";

const columns = [
  {
    title: "频道",
    links: [
      { label: "今日速递", href: "#today" },
      { label: "实时爆料", href: "#live" },
      { label: "大图特辑", href: "#features" },
      { label: "档案合集", href: "#archive" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", href: "#top" },
      { label: "投稿爆料", href: "#subscribe" },
      { label: "联系方式", href: "#subscribe" },
      { label: "免责声明", href: "#live" },
    ],
  },
  {
    title: "关注",
    links: [
      { label: "订阅速递", href: "#subscribe" },
      { label: "热门话题", href: "#live" },
      { label: "最新动态", href: "#today" },
      { label: "新料速递", href: "#features" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 px-4 pt-12 md:px-8 md:pt-16">
      <div className="grid grid-cols-1 gap-10 pb-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
              44
            </span>
            <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
              {mastheadMeta.brand}
            </span>
          </div>
          <p className="mt-4 max-w-sm font-body text-[13px] leading-6 text-secondary-800">
            {mastheadMeta.tagline}
          </p>
          <p className="mt-4 font-label text-xs text-secondary-600">
            {mastheadMeta.date} · {mastheadMeta.issue}
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-700">
              <i className="ri-message-3-line text-base" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-700">
              <i className="ri-live-line text-base" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-700">
              <i className="ri-mail-line text-base" />
            </span>
          </div>
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#top" className="transition-colors duration-200 hover:text-primary-700">
                {col.title}
              </a>
            </h4>
            <ul className="mt-4 space-y-3">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    rel="nofollow"
                    className="font-body text-[13px] text-secondary-800 transition-colors duration-200 hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="flex flex-col items-start justify-between gap-3 border-t border-secondary-300/70 py-6 md:flex-row md:items-center">
        <p className="font-label text-xs text-secondary-600">
          © 2026 {mastheadMeta.brand} · 内容来自网友投稿与公开信息整理
        </p>
        <p className="font-label text-xs text-secondary-600">
          理性吃瓜 · 不传谣 · 不针对任何个人
        </p>
      </div>
    </footer>
  );
}